class StoryVideo {
  constructor(config = {}) {
    const {
      storyVideoSelector
    } = config;
    this.language = NSContext.language;

    this.storyVideos = document.querySelectorAll(storyVideoSelector);

    this.accessibilityText = {
      de: {
        play: {
          active: 'Video pausieren',
          inactive: 'Video abspielen'
        },
        mute: {
          active: 'Video Ton stummschalten',
          inactive: 'Video Ton einschalten'
        }
      },
      fr: {
        play: {
          active: 'mettre en pause la vidéo',
          inactive: 'lire la vidéo'
        },
        mute: {
          active: 'Désactiver le son de la vidéo',
          inactive: 'Activer le son de la vidéo'
        }
      },
    }

    this.bindEvents();
  }

  bindEvents() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('autoplay-started')) {
          entry.target.classList.add('autoplay-started');
          console.log('playing video')
          this.autoPlayVideo(entry.target);
        }
      })
    })

    this.storyVideos.forEach(hero => {
      const video = hero.querySelector('video');

      const play = hero.querySelector('.ns-story-video__control--play');
      const mute = hero.querySelector('.ns-story-video__control--sound');

      video.addEventListener('click', (e) => {
        // this.togglePlayButton(play, !video.paused);
        e.preventDefault();
      });

      // autoplay on intersection
      this.observer.observe(hero);

      // handle buttons
      if (play && mute && video) {
        play.addEventListener('click', (e) => {
          if (play.classList.contains('active')) {
            video.pause();
            this.togglePlayButton(play, false);
          } else {
            this.togglePlayButton(play, true);
            video.play();
          }
        })

        mute.addEventListener('click', (e) => {
          if (mute.classList.contains('active')) {
            video.muted = false;
            this.toggleSoundButton(mute, false);
          } else {
            video.muted = true;
            this.toggleSoundButton(mute, true);
          }
        })
      }
    });
  }

  togglePlayButton(play, activated) {
    if (activated) {
      play.classList.add('active');

      play.setAttribute('aria-pressed', true);
      play.setAttribute('title', this.accessibilityText[this.language].play.active);
    } else {
      play.classList.remove('active');
      play.setAttribute('aria-pressed', false);
      play.setAttribute('title', this.accessibilityText[this.language].play.inactive);
    }

  }

  toggleSoundButton(mute, activated) {
    if (activated) {
      mute.classList.add('active');
      mute.setAttribute('aria-pressed', true);
      mute.setAttribute('title', this.accessibilityText[this.language].mute.inactive);
    } else {
      mute.classList.remove('active');
      mute.setAttribute('aria-pressed', false);
      mute.setAttribute('title', this.accessibilityText[this.language].mute.active);
    }
  }

  autoPlayVideo(hero) {
    const video = hero.querySelector('video');

    const play = hero.querySelector('.ns-story-video__control--play');
    const mute = hero.querySelector('.ns-story-video__control--sound');

    if (video && play && mute) {
      video.muted = true;
      video.play();

      this.togglePlayButton(play, true);
      this.toggleSoundButton(mute, true);
    }
  }

}

export default StoryVideo;
